var map = {
	"./1go.png": 3825,
	"./1go.webp": 1631,
	"./drip.png": 4582,
	"./drip.webp": 5465,
	"./fresh.png": 3892,
	"./fresh.webp": 4235,
	"./izzi.png": 8158,
	"./izzi.webp": 3520,
	"./jet.png": 3157,
	"./jet.webp": 1209,
	"./legzo.png": 3839,
	"./legzo.webp": 3002,
	"./lex.png": 6400,
	"./lex.webp": 2742,
	"./monro.png": 4229,
	"./monro.webp": 8142,
	"./rox.png": 7253,
	"./rox.webp": 7604,
	"./sol.png": 7331,
	"./sol.webp": 4194,
	"./starda.png": 6684,
	"./starda.webp": 3330,
	"./volna.png": 6592,
	"./volna.webp": 1602
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8149;